import { HttpApiError, HttpApiGroup } from "@effect/platform";
import {
  automationExecutionSchema,
  type AutomationExecutionWithFlow,
} from "@redotech/redo-flows-common/automation-execution-definition";
import { ParseResult, Schema } from "effect";

import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { coerceDates } from "../schema/helpers";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type { AutomationExecutionWithFlow as AutomationExecutionResponse } from "@redotech/redo-flows-common/automation-execution-definition";

const AutomationExecutionEffectSchema: Schema.Schema<
  AutomationExecutionWithFlow,
  unknown,
  never
> = Schema.transformOrFail(
  Schema.Unknown,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  Schema.Unknown as Schema.Schema<
    AutomationExecutionWithFlow,
    AutomationExecutionWithFlow
  >,
  {
    strict: true,
    decode: (input, _, ast) => {
      const coerced = coerceDates(input);
      const result = automationExecutionSchema.safeParse(coerced);
      if (!result.success) {
        return ParseResult.fail(
          new ParseResult.Type(
            ast,
            input,
            result.error.issues.map((i) => i.message).join("; "),
          ),
        );
      }
      if (!result.data.flow) {
        return ParseResult.fail(
          new ParseResult.Type(ast, input, "flow is required"),
        );
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      return ParseResult.succeed(result.data as AutomationExecutionWithFlow);
    },
    encode: ParseResult.succeed,
  },
);

export const AutomationExecutionGroup = HttpApiGroup.make("automationExecution")
  .add(
    endpoint.merchant
      .get("getByWorkflowId", "/automation-executions")
      .setUrlParams(Schema.Struct({ workflowId: Schema.String }))
      .addSuccess(Schema.NullOr(AutomationExecutionEffectSchema))
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
